/**
 * /terms — public terms of service. Content in the `legal` i18n namespace
 * (4 languages); layout shared with /privacy via LegalPage.
 */
import { useTranslation } from 'react-i18next';
import { useSeo } from '@/lib/seo';
import { LegalPage, type LegalSection } from './LegalPage';

export default function Terms() {
  const { t } = useTranslation();
  useSeo({ title: t('legal:terms.title'), description: t('legal:terms.intro'), canonicalPath: '/terms' });
  const sections = t('legal:terms.sections', { returnObjects: true }) as LegalSection[];
  return (
    <LegalPage
      title={t('legal:terms.title')}
      intro={t('legal:terms.intro')}
      sections={sections}
    />
  );
}
